import axiosInterceptor from './axiosInterceptor'
import { API_BASE_URL } from './constants'

/**
 * AI usage for admins (MYD-630): GET /api/admin/ai/usage. The shape is
 * backend/controllers/adminAiUsageController.js.
 */

export interface AiUsageTotals {
	calls: number
	costUsd: number
	unpricedCalls: number
	inputTokens: number
	outputTokens: number
	cacheReadTokens: number
	cacheWriteTokens: number
	errors: number
	cacheHitRatio: number | null
	errorRate: number | null
	latencyP50Ms: number | null
	latencyP95Ms: number | null
}

export interface AiUsageDay {
	day: string
	calls: number
	costUsd: number
	inputTokens: number
	outputTokens: number
	cacheReadTokens: number
	cacheWriteTokens: number
	errors: number
}

export interface AiUsage {
	range: { from: string; to: string }
	totals: AiUsageTotals
	byDay: AiUsageDay[]
	byModel: (AiUsageTotals & { model: string })[]
	byOutcome: { outcome: string; calls: number; share: number }[]
	topUsers: { userId: string; name: string | null; email: string | null; calls: number; costUsd: number; tokens: number }[]
	month: { start: string; spentUsd: number; unpricedCeilingUsd: number; capUsd: number; share: number | null }
}

export async function getAiUsage({ from, to }: { from: string; to: string }): Promise<AiUsage> {
	const { data } = await axiosInterceptor(API_BASE_URL).get<AiUsage>('/admin/ai/usage', { params: { from, to } })
	return data
}
